import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { leaveMasterApi } from '../api/leaveMasterApi';
import { appToast } from '../../../../components/AppToast';

const DEFAULT_FORM_STATE = {
  name: '',
  alias: '',
  color: '#3B82F6',
  status: 'Active',
};

export function useLeaveMasterEntry() {
  const { id } = useParams();
  const navigate = useNavigate();
  const editId = id;
  const isEdit = Boolean(editId);

  const [form, setForm] = useState(DEFAULT_FORM_STATE);
  const [isLoading, setIsLoading] = useState(isEdit);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (isEdit) {
      setIsLoading(true);
      leaveMasterApi
        .getRecordById(editId)
        .then((record) => {
          if (record) {
            setForm({
              name: record.name || '',
              alias: record.alias || '',
              color: record.color || '#3B82F6',
              status: record.status || 'Active',
            });
          } else {
            appToast.error('Leave type record not found.');
            navigate('/payroll/leave-master');
          }
        })
        .catch(() => {
          appToast.error('Failed to load leave type details.');
          navigate('/payroll/leave-master');
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [editId, isEdit, navigate]);

  const patchForm = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async ({ exitAfter = true } = {}) => {
    if (!form.name.trim()) {
      appToast.error('Leave Name is required.');
      return;
    }

    setIsSaving(true);
    try {
      if (isEdit) {
        await leaveMasterApi.updateRecord(editId, form);
        appToast.success('Leave type updated successfully!');
      } else {
        await leaveMasterApi.createRecord(form);
        appToast.success('Leave type created successfully!');
      }

      if (exitAfter) {
        navigate('/payroll/leave-master');
      } else if (!isEdit) {
        setForm(DEFAULT_FORM_STATE);
      }
    } catch (err) {
      const errorMsg = err?.response?.data?.detail || 'Failed to save Leave type.';
      appToast.error(errorMsg);
    } finally {
      setIsSaving(false);
    }
  };

  return {
    state: {
      form,
      isEdit,
      editId,
      isLoading,
      isSaving,
    },
    actions: {
      patchForm,
      handleSave,
    },
  };
}
